import React from "react";
import PageLayout from "../components/PageLayout";

export default function Agencia() {
  const cards = [
    {
      title: "Identidade visual",
      text: "Construção ou organização dos elementos que dão unidade e reconhecimento à marca.",
      points: ["Logótipo", "Cores e tipografia", "Aplicações"],
    },
    {
      title: "Design de comunicação",
      text: "Materiais claros e atractivos para campanhas, eventos, vendas e comunicação interna.",
      points: ["Cartazes", "Apresentações", "Conteúdo digital"],
    },
    {
      title: "Produção gráfica",
      text: "Acompanhamento do design à impressão para preservar qualidade, cor e acabamento.",
      points: ["Preparação técnica", "Impressão", "Controlo de qualidade"],
    },
  ];
  return (
    <PageLayout
      eyebrow="Agência CENFOTEP"
      title="Comunicação com intenção, clareza e qualidade."
      intro="A nossa agência combina pensamento visual e capacidade de produção para ajudar marcas a apresentar-se com profissionalismo."
      sectionTitle="Da ideia à peça final"
      sectionIntro="Centralizar design e produção reduz erros, acelera aprovações e garante maior consistência entre o que foi criado e o que será entregue."
      cards={cards}
    />
  );
}
